module.exports = __webpack_public_path__ + "static/media/pencil-edit.b0753817.svg";